import EntryPoint from './Pages/App/index';
import ThemeProvider from './Utils/themeProvider';
import { createTheme } from "@material-ui/core/styles";
import { SnackbarProvider } from 'notistack';
import './App.css'; 

  const theme = createTheme({
    typography: {
      allVariants: {
        fontFamily: ['Lato', "sans-serif"].join(","),
        textTransform: "none",
      },
    },
  });

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <EntryPoint />
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
